module.exports = __webpack_public_path__ + "static/1.f21621bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/korea/1.jpg
// module id = 132
// module chunks = 92919436940798 165889800748998